import { render, staticRenderFns } from "./sliderChannels.vue?vue&type=template&id=6bbdc9b2&scoped=true&"
import script from "./sliderChannels.vue?vue&type=script&lang=js&"
export * from "./sliderChannels.vue?vue&type=script&lang=js&"
import style0 from "./sliderChannels.vue?vue&type=style&index=0&id=6bbdc9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbdc9b2",
  null
  
)

export default component.exports